import { render, staticRenderFns } from "./testPaperPreview.vue?vue&type=template&id=16aff2c5"
import script from "./testPaperPreview.vue?vue&type=script&lang=js"
export * from "./testPaperPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports